import { render, staticRenderFns } from "./ClientProjectsCoreSelect.vue?vue&type=template&id=1c84dfc8&"
import script from "./ClientProjectsCoreSelect.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsCoreSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports